import { Shield } from "lucide-react";

export default function PrivacyPage() {
  return (
    <div className="py-12 md:py-16 px-4 bg-content min-h-screen" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-amber-500/20 bg-amber-500/5 text-amber-400 text-xs font-medium mb-3">
            <Shield className="w-3 h-3" /> Legal
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2" data-testid="privacy-heading">Privacy Policy</h1>
          <p className="text-sm text-slate-500">Last updated: April 2026</p>
        </div>

        <div className="prose-invert space-y-6 text-slate-400 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Information We Collect</h2>
            <p>We collect information you provide directly to us, including but not limited to: business name, contact information, financial data, bank account details, and any other information you submit through our forms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. How We Use Your Information</h2>
            <p>We use the information we collect to: process your funding applications, match you with appropriate lenders, communicate with you about your application status, improve our services, and comply with legal obligations.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Information Sharing</h2>
            <p>We may share your information with: lending partners to facilitate your funding request, service providers who assist in our operations, and as required by law. We do not sell your personal information to third parties.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Data Security</h2>
            <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. All data transmissions are encrypted using industry-standard SSL/TLS protocols.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Your Rights</h2>
            <p>You have the right to: access your personal data, request correction of inaccurate data, request deletion of your data, opt out of marketing communications, and lodge a complaint with a supervisory authority.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Cookies</h2>
            <p>We use essential cookies to ensure proper functioning of our website. We may also use analytics cookies to understand how visitors interact with our site. You can control cookie preferences through your browser settings.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">7. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at: <span className="text-amber-400">applications@easyquickfund.com</span></p>
          </section>
        </div>
      </div>
    </div>
  );
}
